module.exports = __webpack_public_path__ + "img/stop.12c80e01.svg";